import { RequestService } from '../../../../common/services/RequestService';
import { API_PROFILE_INFO } from '../constants';
import { adjustProfileData } from './AdjustProfileData';

export const getProfileInfoRequest = async profileId => {
  const response = await RequestService.get(API_PROFILE_INFO + profileId);
  return adjustProfileData(response.data);
};
